// Variant Display Fix - Proper variant selector functionality
document.addEventListener('DOMContentLoaded', function() {
  try {
    // Only run on product pages
    var body = document.body;
    var isProduct = body && (body.className.indexOf('template-product') > -1 || body.className.indexOf('template-product ') > -1);
    if (!isProduct) return;
  } catch(e) { /* if in doubt, keep running on product only */ }
  
  // Function to enhance variant selection
  function enhanceVariantSelection() {
    
    // Let the theme handle dropdown behavior completely - it has data-dropdown-off attribute
    // We only need to handle variant changes, not dropdown closing
    
    // Listen for dropdown item clicks to trigger variant changes
    document.addEventListener('click', function(e) {
      const dropdownItem = e.target.closest('.t4s-dropdown__content .t4s-swatch__item[data-value]');
      if (dropdownItem && !dropdownItem.classList.contains('is--soldout') && !dropdownItem.classList.contains('is--unavailable')) {
        const value = dropdownItem.getAttribute('data-value');
        const optionIndex = dropdownItem.closest('[data-swatch-option]').getAttribute('data-id');
        
        // Trigger variant change after a short delay to let the theme handle the dropdown closing
        setTimeout(() => {
          triggerVariantChange(optionIndex, value);
        }, 100);
      }
    });
    
    // Handle regular variant items (non-dropdown)
    const variantItems = document.querySelectorAll('.t4s-swatch__item[data-value]:not(.t4s-dropdown__content .t4s-swatch__item)');
    
    variantItems.forEach(item => {
      // Skip if it's a color swatch
      if (item.closest('.is-t4s-style__color')) {
        return;
      }
      
      // Add click handler for variant selection
      item.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Skip if sold out or unavailable
        if (this.classList.contains('is--soldout') || this.classList.contains('is--unavailable')) {
          return;
        }
        
        const value = this.getAttribute('data-value');
        const optionIndex = this.closest('[data-swatch-option]').getAttribute('data-id');
        
        // Update selection visually
        const parentList = this.closest('.t4s-swatch__list');
        if (parentList) {
          parentList.querySelectorAll('.t4s-swatch__item').forEach(sibling => {
            sibling.classList.remove('is--selected');
          });
        }
        
        this.classList.add('is--selected');
        
        // Update the current value display
        const currentValueSpan = this.closest('.t4s-swatch__option').querySelector('[data-current-value]');
        if (currentValueSpan) {
          currentValueSpan.textContent = value;
        }
        
        // Trigger variant change after a short delay to ensure DOM is updated
        setTimeout(() => {
          triggerVariantChange(optionIndex, value);
        }, 10);
      });
      
      // Add hover effects
      item.addEventListener('mouseenter', function() {
        if (!this.classList.contains('is--soldout') && !this.classList.contains('is--unavailable')) {
          this.style.transform = 'translateY(-1px)';
          this.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
        }
      });
      
      item.addEventListener('mouseleave', function() {
        this.style.transform = '';
        this.style.boxShadow = '';
      });
    });
  }
  
  // Function to trigger variant change
  function triggerVariantChange(optionIndex, value) {
    // Find the hidden select element
    const selectElement = document.querySelector('.t4s-product__select');
    if (!selectElement) return;
    
    // Get all currently selected option values
    const selectedOptions = getSelectedOptions();
    
    // Find the variant that matches ALL selected options
    const options = selectElement.querySelectorAll('option');
    let targetVariant = null;
    
    for (let option of options) {
      const variantTitle = option.textContent.trim();
      const variantOptions = variantTitle.split(' / ');
      
      // Check if this variant matches all selected options
      if (matchesSelectedOptions(variantOptions, selectedOptions)) {
        targetVariant = option.value;
        break;
      }
    }
    
    if (targetVariant) {
      // Update the select element
      selectElement.value = targetVariant;
      
      // Get variant data from window.productVariants or parse from JSON
      let variantData = null;
      
      // Try to get from global productVariants
      if (window.productVariants && Array.isArray(window.productVariants)) {
        variantData = window.productVariants.find(v => v.id == targetVariant);
      }
      
      // If not found, try to parse from JSON script
      if (!variantData) {
        const variantsScript = document.querySelector('.pr_variants_json');
        if (variantsScript) {
          try {
            const variants = JSON.parse(variantsScript.textContent);
            variantData = variants.find(v => v.id == targetVariant);
          } catch (e) {
            console.warn('Failed to parse variants JSON:', e);
          }
        }
      }
      
      // Update price elements if we have variant data
      if (variantData) {
        const variantPrice = variantData.price;
        const variantComparePrice = variantData.compare_at_price || variantPrice;
        
        // Update price elements manually - check all possible price selectors
        const priceElements = document.querySelectorAll('[data-pr-price], [data-product-price], [data-product-unit-price], .t4s-product-price');
        priceElements.forEach(priceEl => {
          if (variantPrice) {
            // Format price (assuming it's in cents)
            const price = parseFloat(variantPrice) / 100;
            const comparePrice = parseFloat(variantComparePrice) / 100;
            
            // Format as currency
            const formattedPrice = new Intl.NumberFormat('en-GB', {
              style: 'currency',
              currency: 'GBP'
            }).format(price);
            
            // When a specific variant is selected, show exact price (no "From")
            if (comparePrice > price) {
              const formattedComparePrice = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP'
              }).format(comparePrice);
              
              priceEl.innerHTML = `<del>${formattedComparePrice}</del> <ins>${formattedPrice}</ins>`;
            } else {
              priceEl.textContent = formattedPrice;
            }
          }
        });
        
        // Update sticky price if exists
        const stickyPrice = document.querySelector('[data-sticky-price]');
        if (stickyPrice && variantPrice) {
          const price = parseFloat(variantPrice) / 100;
          const formattedPrice = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP'
          }).format(price);
          
          if (parseFloat(variantComparePrice) > parseFloat(variantPrice)) {
            const comparePrice = parseFloat(variantComparePrice) / 100;
            const formattedComparePrice = new Intl.NumberFormat('en-GB', {
              style: 'currency',
              currency: 'GBP'
            }).format(comparePrice);
            stickyPrice.innerHTML = `<del>${formattedComparePrice}</del> <ins>${formattedPrice}</ins>`;
          } else {
            stickyPrice.textContent = formattedPrice;
          }
        }
      }
      
      // Trigger change event to let theme handle other updates
      const event = new Event('change', { bubbles: true });
      selectElement.dispatchEvent(event);
      
      // Also trigger input event in case theme listens to that
      const inputEvent = new Event('input', { bubbles: true });
      selectElement.dispatchEvent(inputEvent);
      
      // Update URL with variant parameter safely
      try {
        const currentUrl = new URL(window.location);
        const productHandle = currentUrl.pathname.split('/').pop();
        
        // Only update URL if we have a valid product handle
        if (productHandle && productHandle !== 'undefined' && productHandle !== '') {
          currentUrl.searchParams.set('variant', targetVariant);
          window.history.replaceState({}, '', currentUrl);
        } else {
          console.warn('🔇 Skipping URL update - invalid product handle:', productHandle);
        }
      } catch (error) {
        console.warn('🔇 Error updating URL:', error);
      }
    }
  }
  
  // Function to get all currently selected option values
  function getSelectedOptions() {
    const selectedOptions = [];
    const swatchOptions = document.querySelectorAll('.t4s-swatch__option');
    
    swatchOptions.forEach(option => {
      // Check for dropdown selection first
      const dropdownButton = option.querySelector('[data-dropdown-open]');
      if (dropdownButton) {
        const currentValueSpan = dropdownButton.querySelector('[data-current-value]');
        if (currentValueSpan) {
          selectedOptions.push(currentValueSpan.textContent.trim());
        }
      } else {
        // Check for regular selection
        const selectedItem = option.querySelector('.t4s-swatch__item.is--selected');
        if (selectedItem) {
          selectedOptions.push(selectedItem.getAttribute('data-value'));
        }
      }
    });
    
    return selectedOptions;
  }
  
  // Function to check if variant options match selected options
  function matchesSelectedOptions(variantOptions, selectedOptions) {
    if (variantOptions.length !== selectedOptions.length) {
      return false;
    }
    
    // Check if all selected options are present in the variant
    for (let selectedOption of selectedOptions) {
      if (!variantOptions.includes(selectedOption)) {
        return false;
      }
    }
    
    return true;
  }
  
  // Function to initialize variant display
  function initVariantDisplay() {
    // Add proper styling classes
    const variantOptions = document.querySelectorAll('.t4s-swatch__option:not(.is-t4s-style__color)');
    
    variantOptions.forEach(option => {
      // Ensure proper variant styling
      const items = option.querySelectorAll('.t4s-swatch__item');
      items.forEach(item => {
        // Remove any color-specific classes
        item.className = item.className.replace(/bg_color_[^\s]+/g, '');
        
        // Add proper variant styling
        if (!item.classList.contains('variant-item')) {
          item.classList.add('variant-item');
        }
      });
    });
    
    enhanceVariantSelection();
  }
  
  // Initialize on page load
  initVariantDisplay();
  
  // Re-initialize after dynamic content loads
  setTimeout(initVariantDisplay, 1000);
  
  // Listen for dynamic content changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if new variant options were added
        const hasNewVariants = Array.from(mutation.addedNodes).some(node => {
          return node.nodeType === 1 && (
            node.classList.contains('t4s-swatch__item') ||
            node.querySelector('.t4s-swatch__item')
          );
        });
        
        if (hasNewVariants) {
          setTimeout(initVariantDisplay, 100);
        }
      }
    });
  });
  
  // Start observing
  if (document.body) {
    observer.observe(document.body, {
    childList: true,
    subtree: true
    });
  }
});